import { render, staticRenderFns } from "./TrxBudgeting.vue?vue&type=template&id=c7f6923e&"
import script from "./TrxBudgeting.vue?vue&type=script&lang=js&"
export * from "./TrxBudgeting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TrxBudgeting.vue"
export default component.exports